export const ROLE_PATIENT = "patient";
export const ROLE_DOCTOR = "doctor";

export const normalizeGuidedRole = (role) =>
  String(role || ROLE_PATIENT).toLowerCase() === ROLE_DOCTOR ? ROLE_DOCTOR : ROLE_PATIENT;
